export enum MetricsEnum {
  NONE,
  SPAIN,
  PORTUGAL,
  ARGENTINA,
  ECUADOR,
}
